import { postQueryAction } from "../shared/queryActionsModel";

export function cancelTask(queryPk, userId, reason) {
  return postQueryAction(queryPk, "cancel", { userId, reason });
}

export function moveStatusBack(queryPk, userId, toStatus, reason) {
  return postQueryAction(queryPk, "move-status", { userId, to_status: toStatus, reason });
}

export function moveStatusForward(queryPk, userId, toStatus, reason) {
  return postQueryAction(queryPk, "move-status-forward", { userId, to_status: toStatus, reason });
}

export function reassignTask(queryPk, toUserId, reason, userId) {
  return postQueryAction(queryPk, "reassign", { to_user_id: toUserId, reason, userId });
}

export function unparkTask(queryPk, userId, toStatus, reason) {
  return postQueryAction(queryPk, "unpark", { userId, to_status: toStatus, reason });
}

export function notifyUnavailableParts(queryPk, { userId, messageText, partIds }) {
  return postQueryAction(queryPk, "notify-unavailable-parts", { userId, message_text: messageText, part_ids: partIds });
}

export function requestBillingDetails(queryPk, userId, messageText) {
  return postQueryAction(queryPk, "request-billing-details", { userId, message_text: messageText });
}
